<!--顾问支持确认单-->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">售前顾问跟进确认信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :showSaveBtn="isEdit"
          :disabled="!isEdit"
          ref="form"
          @input="handInput"
          />
      </div>
      <folded-panel infoName="附件">
        <div slot="content">
          <el-upload
            v-if="isEdit"
            class="upload-demo"
            :action="actionUrl"
             :headers="uploadHeaders"
            :on-success="handleSuccess"
            :file-list="fileId"
            :show-file-list="true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-preview="preview"
            style="margin:14px;">
            <el-button size="small" type="primary">附件上传</el-button>
          </el-upload>
          <div class="file-box" v-if="!isEdit">
            <div v-for="item in fileId" :key='item.id' class="file-item">
               <el-button @click="preview(item)">{{item.name}}</el-button>
               <!-- <i class="el-icon-close file-close" v-if="isEdit" @click="delFile(item,index)"></i> -->
            </div>
          </div>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)">保存</el-button>
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </div>
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import initDict from "@/mixin/initDict";
  import {getDocumentCode} from '@/views/utils'
  import CrudMixin from "@/mixins/CrudMixin";
  import {downLoad,delFile} from '@/api/bill/contract'
  import {add,queryById} from '@/api/bill/counselor'
  import { getToken } from "@/utils/auth";
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
import DragDialog from "@/components/DragDialog"
  export default {
    name: "NewCustomer",
    components: {
      FoldedPanel,DragDialog,PersonStep
    },
    mixins: [DataTableMixin,initDict,CrudMixin],
    data() {
      return {
        uploadHeaders: {},
        actionUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
        fileList: [],
        delLoading: false,
        loading: false,
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "单据编号",
              value: "",
              disabled: true,
              span: 8,
            },
            {
              type: "databox",
              key: "preSaleApplicationId",
              label: "顾问申请单",
              placeholder: "请选择申请单",
              value: "",
              span: 8,
              props: {label: "name", value: "id"},
              url: "biz-pre-sale-application/getList",
              tableColumn: [
              {
                  property: "code",
                  label: "申请单",
              },
              {
                  property: "name",
                  label: "申请名称",
                  query: {
                  type: "input"
                  }
              }
              ],
              extendParms: { queryFieldItem: "id,number,name" },
              multiple: false,
            },
            {
              type: "databox",
              key: "bsProject",
              label: "项目名称",
              placeholder: "请选择项目",
              value: "",
              span: 8,
              props: {
              label: "name",
              value: "code"
              },
              url: "/bizTaskDecomposition/findProject",
              tableColumn: [
              {
                  property: "code",
                  label: "项目号",
                  query: {
                  type: "input"
                  }
              },
              {
                  property: "name",
                  label: "项目名称",
                  query: {
                  type: "input"
                  }
              }
              ],
              extendParms: { queryFieldItem: "id,number,name" },
              multiple: false,
              rules: {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
          },
          {
              type: "input",
              key: "projectCode",
              label: "项目编号",
              value: "",
              span: 8,
              disabled: true
            },
            {
              label: '机构参与人',
              key: 'organizationParticipant',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              multiple: false,
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "code",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,code,name'},
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              label: '客户参与人员',
              key: 'clientParticipant',
              type: 'input',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "code",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,code,name'},
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              type: "date",
              key: "supportStartDate",
              value: "",
              label: "支持开始时间",
              span: 8,
              valueFormat: "yyyy-MM-dd"
            },
            {
              type: "date",
              key: "supportEndDate",
              value: "",
              label: "支持结束时间",
              span: 8,
              valueFormat: "yyyy-MM-dd"
            },
            {
              type: "input",
              key: "supportFruit",
              value: "",
              label: "支持成果",
              span: 8,
            },
            {
              label: "支持方式",
              key: "supportType",
              type: "select",
              disabled: false,
              multiple: true,
              value: [],
              span: 8,
              options: []
            },
            {
                type: "input",
                key: "summary",
                value: "",
                label: "支持活动纪要",
                span: 20,
                subtype: 'textarea',
                maxlength: 200,
            },
            {
                type: "input",
                key: "problemSolving",
                value: "",
                label: "重要问题及应对",
                subtype: 'textarea',
                span: 20,
                maxlength: 200,
            },
            {
                type: "input",
                key: "workSuggest",
                value: "",
                label: "下阶段工作建议",
                subtype: 'textarea',
                span: 20,
                maxlength: 200,
            },
            {
                type: "textarea",
                key: "assess",
                value: "",
                label: "效果评估",
                span: 13,
            },
            {
                type: "textarea",
                key: "opinion",
                value: "",
                label: "营销中心、事业部总监意见",
                span: 13,
            },
              // 备注
              {
                span: 20,
                type: "input",
                key: "remark",
                label: "备注",
                disable: false,
                subtype: 'textarea',
                value: "",
                placeholder: "请输入备注",
                maxlength: 200,
              }
          ]
        },
        form: {},
        editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          bsPerformanceCompositionList: [
            {
              label: '预算项目',
              prop: 'projectBudgetId',
              editRender: {
                type: 'default',
                name: 'ElInput',
              }
            },
            {
              label: '费用类型',
              prop: 'costTypeId',
             editRender: {
                type: 'default', name: 'ElSelect',options: [],
              }
            },
            {
              label: '金额',
              prop: 'balance',
              editRender: {type: 'date', name: 'ElInput'}
            },
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }

          ],
        },
         validRules: {
            balance: [
                {pattern: /^\d+\.?(\d{1,2})?$/,message: '小数点后保留两位',trigger: "change"}
              ]
          },
        isEdit: false,
        headLevels: [
          // { label: "编码", property: "code" },
          { label: "名称", property: "budgetItemName", query: { type: "input" } },
          { label: "结余金额", property: "balance" }
        ],
        validateRefNames: ['form'],
        constMoneys: [],
        fileId: [],// 文件上传
        personStepData: [],
        form2: {}, // hr审批
        assignData: {}, // hr审批人员信息
        stepShow: false,
      }
    },
    created() {
       this.uploadHeaders = { Authorization: `Bearer ${getToken()}` }
       this.id = this.$route.params.id;
      this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
      if (!this.id) {
        this.form.code = getDocumentCode('GWZCQR');
      } else {
        queryById(this.id).then(res => {
          if (res.code === 200) {
            const data = res.data;
            this.form = data.counselorAffirm;
            this.form.supportType ? this.form.supportType = this.form.supportType.split(",") : this.form.supportType = []
            this.form.preSaleApplicationId = {
              id: data.counselorAffirm.preSaleApplicationId,
              name: data.counselorAffirm.preSaleApplicationName
            };
            this.form.organizationParticipant = {
              id: data.counselorAffirm.organizationParticipant,
              name: data.counselorAffirm.organizationParticipantName
            };
            this.form.bsProject = {
              name: data.counselorAffirm.projectName,
              code: data.counselorAffirm.projectCode
            }
            this.fileId = data.bizAttachmentList;
            this.fileList = data.bizAttachmentList;
          }
        });
      }
      // 支持方式
      this.getDict("supportWay").then(res => {
        this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'supportType')].options = res.data;
      });
    },
    methods: {
      // 表单值改变
      handInput(val,key) {
        switch (key) {
          case "bsProject":
            if (val[key]) {
              this.form.projectCode = val[key].code
            } else {
              this.form.projectCode = ""
            }
            break;
          case "":
            break;
          default:
            break;
        }
      },
      // 上传成功回调
      handleSuccess(res) {
        if (res.code === 200) {
           this.$notify({ title: "上传成功！", type: "success", duration: 1500 });
           this.fileId.push(res.data)
        }
      },
      // 下载文件
      preview(file) {
        console.log(file)
        downLoad(file.id,file.name)
      },
      beforeRemove(file, fileList) {
        // if (!this.isEdit) {
        //   return this.$notify({ title: "查看页面不能进行删除", type: "error", duration: 1500 });
        // }
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 删除文件
      handleRemove(file, fileList) {
        delFile(file.id).then(res => {
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
            this.fileId = fileList
        })
      },
      // 保存
      save(status) {
        this.loading =  true;
        // this.getFormData(status)
        this.pull(this.getFormData(status))
      },
        close() {
        this.stepShow = false;
    },
    submitConfirm(val) {
      // this.getFormData(2,val)
      this.loading = true
       const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = "followupForm_affirm"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
      // 提交
      submit(status) {
         this.loading =  true;
        this._validateForm(this.validateRefNames).then((res) => {
        // this.pull(this.getFormData(status))
          getFlowNode({ from: "followupForm_affirm", id: this.form.id }).then(res => {
             this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        });
      }).catch(e => { this.loading = false })
      },
      cancel() {
        this.$router.go(-1);
      },
      // 封装表单数据
      getFormData(status) {
        const obj = {...this.form}
        obj.billState = status;
        obj.preSaleApplicationId = obj.preSaleApplicationId.id
        obj.organizationParticipant = obj.organizationParticipant.id
        obj.supportType = obj.supportType.join(",")
        return { counselorAffirm: obj,bizAttachmentList: this.fileId}
      },
      pull(obj) {
          add(obj).then(res => {
          this.loading = false;
          if (res.code === 200) {
              this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
              this.cancel();
          }
          }).catch(e => { this.loading = false });
      },
    }

  }
</script>

<style lang="scss" scoped>
.el-upload-list__item{
  width:30%;
}
  .app-container {
     .file-box {
      margin-top: 10px;
      display: flex;
      position: relative;
      padding: 10px;
      .file-item{
        position: relative;
        margin-right: 14px;
        .file-close{
          position: absolute;
          left: 0px;
          top: -6px;
          font-size: 14px;
        }
      }
    }
    .box-card {
      background-color: #fff;
      padding: 20px 30px 20px 30px;
      border-radius: 10px;

      .content-title {
        height: 40px;
        background-color: #e7eff6;
        padding-left: 20px;
        overflow: hidden;

        .title-icon {
          display: inline-block;
          margin-top: 8px;
          width: 6px;
          height: 24px;
          background-color: #1369a8;
          margin-right: 14px;
        }

        .title-details {
          overflow: hidden;
          line-height: 20px;
          display: inline-block;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          font-family: SourceHanSansSC-regular;
        }
      }

      .button {
        padding-top: 20px;
        text-align: right;

        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }

        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
    }
  }
</style>
